import { FormControl, FormGroup, AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { FormConfig } from '../formbuilder/form-config';
import { IFormControl } from '../formbuilder/formcontrol.interface';
import { FormValidatorType } from '../formbuilder/form-validator-type';
import { InputType } from '../formbuilder/input-type';
import { BirthDateValidator } from '../../validators/birthdate';
import { MaxMinDateValidator } from '../../validators/maxMinDate';
import { MaxDateValidator } from '../../validators/maxDate';
import { PixValidator } from '../../validators/pixValidator';
import { BreBValidator } from '../../validators/breBValidator';
import { ADDITIONAL_DETAILS_FIELDS_ID } from '../myria/app-variables';

export class DynamicFormBuilder {
  formConfigs: IFormControl[];

  constructor(formControls: IFormControl[]) {
    this.formConfigs = formControls;
  }

  buildAbstractControls(controls: IFormControl[], errorFields?: any[]): { [name: string]: AbstractControl } {
    const abstractControls = {};
    controls.forEach(control => {
      const validators = this.buildValidators(control);
      const formControl = new FormControl({ value: this.buildDefaultValue(control), disabled: !!control.disabled }, validators);
      if(errorFields) {
        let field = errorFields.filter(field => field.FieldId == control.id)[0];
        if(field) {
          formControl.setErrors({ 'invalidField': field.TranslatedErrorMessage });
          formControl.markAsTouched();
        }
      }
      abstractControls[control.id] = formControl;
    })
    return abstractControls;
  }

  private buildDefaultValue(control: IFormControl): string | boolean {
    if (control.value) {
      return control.value;
    }
    switch (control.type) {
      case InputType.Text:
        return '';
      case InputType.Toggle:
      case InputType.CheckBox:
        return false;
      default:
        return '';
    }
  }

  private buildValidators(control: IFormControl): ValidatorFn[] {
    if (control.id === '14901') // ID expiration date
      control.validators.push({ type: FormValidatorType.RelativeMinDate });
    else if (control.id === '16901') // ID issue date
      control.validators.push({ type: FormValidatorType.RelativeMaxDate });
    else if(control.id === '15201' || control.id === '5')// Date of birth
      control.validators.push({ type: FormValidatorType.BirthDate });
    else if (this.isBeneficiaryDateOfBirth(control))
      control.validators.push({ type: FormValidatorType.RelativeMaxDate });
      else if(control.id === 'pIX') {
        control.validators.push({type: FormValidatorType.PixError});
      }
      else if(control.id === 'breB') {
        control.validators.push({type: FormValidatorType.BreBError});
      }
    const validators = [];
    for (const validator of control.validators) {
      switch (validator.type) {
        case FormValidatorType.Required: {
          if (control.type === InputType.CheckBox)
            validators.push(Validators.requiredTrue);
          else
            validators.push(Validators.required);
          break
        }
        case FormValidatorType.MinLength: {
          validators.push(Validators.minLength(validator.minLength));
          break
        }
        case FormValidatorType.PixError: {
          validators.push(PixValidator.checkPixError.bind(control));
          break;
        }
        case FormValidatorType.BreBError: {
          validators.push(BreBValidator.checkBreBError.bind(control));
          break;
        }
        case FormValidatorType.MaxLength: {
            validators.push(Validators.maxLength(validator.maxLength));
          break
        }
        case FormValidatorType.MinValue: {
          validators.push(Validators.min(validator.minValue));
          break
        }
        case FormValidatorType.MaxValue: {
          validators.push(Validators.min(validator.maxValue));
          break
        }
        case FormValidatorType.Regex: {
          validators.push(Validators.pattern(validator.regex));
          break
        }
        case FormValidatorType.BirthDate:{
          validators.push(BirthDateValidator.checkBirthDate.bind(control));
          break;
        }
        case FormValidatorType.RelativeMinDate:{
          validators.push(MaxMinDateValidator.checkMaxMinDate.bind(control));
          break;
        }
        case FormValidatorType.RelativeMaxDate:{
          validators.push(MaxDateValidator.checkMaxDate.bind(control));
          break;
        }        
        case FormValidatorType.Custom: {
          validators.push(validator.test)
        }
      }
    }
    return validators;
  }

  private isBeneficiaryDateOfBirth(control: IFormControl): boolean {
    return control.id === ADDITIONAL_DETAILS_FIELDS_ID.STAGED_TRX_BEN_DOB || control.id === ADDITIONAL_DETAILS_FIELDS_ID.BEN_DOB;
  }
}



// WEBPACK FOOTER //
// ./src/providers/formbuilder/dynamic-form-builder.ts